export default "__VITE_ASSET__DIucXe22__"